import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cb43f814 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _0cb663f5 = () => interopDefault(import('..\\pages\\errors\\index.vue' /* webpackChunkName: "pages_errors_index" */))
const _01ca0193 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _9905021e = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _682047aa = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _1f42f746 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _69da9645 = () => interopDefault(import('..\\pages\\upload-copay-documents\\index.vue' /* webpackChunkName: "pages_upload-copay-documents_index" */))
const _eb72c0b8 = () => interopDefault(import('..\\pages\\upload-documents-success.vue' /* webpackChunkName: "pages_upload-documents-success" */))
const _3c72481b = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _6edc51aa = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _c3a76ce4 = () => interopDefault(import('..\\pages\\patient\\patient-authorization.vue' /* webpackChunkName: "pages_patient_patient-authorization" */))
const _5a728bc4 = () => interopDefault(import('..\\pages\\patient\\patient-authorization-success.vue' /* webpackChunkName: "pages_patient_patient-authorization-success" */))
const _47042ffe = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _2ef2a912 = () => interopDefault(import('..\\pages\\patient\\prescriber-information.vue' /* webpackChunkName: "pages_patient_prescriber-information" */))
const _00d62236 = () => interopDefault(import('..\\pages\\upload-copay-documents\\success.vue' /* webpackChunkName: "pages_upload-copay-documents_success" */))
const _5697e5c0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _cb43f814,
    name: "error"
  }, {
    path: "/errors",
    component: _0cb663f5,
    name: "errors"
  }, {
    path: "/not-eligible",
    component: _01ca0193,
    name: "not-eligible"
  }, {
    path: "/success",
    component: _9905021e,
    name: "success"
  }, {
    path: "/thank-you",
    component: _682047aa,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _1f42f746,
    name: "unlock"
  }, {
    path: "/upload-copay-documents",
    component: _69da9645,
    name: "upload-copay-documents"
  }, {
    path: "/upload-documents-success",
    component: _eb72c0b8,
    name: "upload-documents-success"
  }, {
    path: "/errors/404",
    component: _3c72481b,
    name: "errors-404"
  }, {
    path: "/patient/eligibility",
    component: _6edc51aa,
    name: "patient-eligibility"
  }, {
    path: "/patient/patient-authorization",
    component: _c3a76ce4,
    name: "patient-patient-authorization"
  }, {
    path: "/patient/patient-authorization-success",
    component: _5a728bc4,
    name: "patient-patient-authorization-success"
  }, {
    path: "/patient/patient-information",
    component: _47042ffe,
    name: "patient-patient-information"
  }, {
    path: "/patient/prescriber-information",
    component: _2ef2a912,
    name: "patient-prescriber-information"
  }, {
    path: "/upload-copay-documents/success",
    component: _00d62236,
    name: "upload-copay-documents-success"
  }, {
    path: "/",
    component: _5697e5c0,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
